<section id="montreal-faca-as-contas">
  <div class="container is-fullhd">
    <div class="columns">
      <div class="column is-offset-1 is-5" id="area-text-contas">
        <h1>Faça as contas</h1>

        <h5>Plano Tranquilidade</h5>
        <p>Para quem quer passar uma temporada de descanso, fugir da rotina, se divertir e ficar sossegado sem gastar
          muito. O plano Tranquilidade oferece apartamentos para duas ou três pessoas e diárias com café da manhã.</p>

        <h5>Plano Conforto</h5>
        <p>Para uma viagem sem preocupação, com benefícios incríveis e um toque de luxo. O plano oferece hotéis
          exclusivos com apartamentos da categoria superior e diárias para duas ou três pessoas com café da manhã e
          <strong>seguro-viagem.</strong></p>
        <br>

        <!-- <a href="/faca-parte" class="btn btn-primary">Monte Seu Plano Agora</a> -->
        <a class="btn btn-primary" (click)="persistirProposta()">Monte Seu Plano Agora</a>
        <br>
        <a href="/contatos" class="link-call"><i class="fas fa-comment"></i> Ainda em dúvida? Fale com a gente</a>

      </div>
      <div class="column  is-5">

        <div class="area-table-fake">

          <div class="lista-valores-head">
            <div class="item"><strong>Diárias</strong></div>
            <div class="item"><strong>Parcela</strong>/mês</div>
            <div class="item"><strong>Total</strong>/Ano</div>
          </div>

          <div class="area-select select-pessoas">
            <i class="fas fa-user-plus"></i>
            <select (change)="buscaValoresPlano()" [(ngModel)]="qtdPessoaSelecionado">
              <option value="DUPLO">2 pessoas</option>
              <option value="TRIPLO">3 pessoas</option>
            </select>
            <i class="fas fa-chevron-down"></i>
          </div>

          <div class="area-select select-plano">
            <select (change)="buscaValoresPlano()" [(ngModel)]="planoSelecionado">
              <option value="TRANQUILIDADE">Plano Tranquilidade</option>
              <option value="CONFORTO">Plano Conforto</option>
            </select>
            <i class="fas fa-chevron-down"></i>
          </div>
          <div style="height: 400px; overflow: auto;">
            <div class="lista-valores" *ngFor="let item of valoresPlanoList"
              [ngClass]="{'destaque': item.destaque == true }">
              <div class="item-list">{{item.quantidade_diarias}}</div>
              <div class="item-list">{{item.valor}}</div>
              <div class="item-list">{{item.totalAno}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
